import React, { useCallback, useMemo, useState, useEffect } from 'react';
import css from './styles.module.scss';
import { useSelector } from 'react-redux';
import { selectNewDeal } from '~/features/dashboard/store/selectors';
import { useForm } from 'react-hook-form';
import { StepControls } from '~/common/step-controls';
import { AccountingTerm } from '~/models/deals/new-deal/helpers';
import { INewDealStepFourFormInputs } from '~/models/deals/new-deal/formInputs';
import { createNewDealStepFourThunk } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { deepEqual } from '~/utils/helpers';
import {
    Typography,
    Grid,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    List,
    ListItem,
    Checkbox,
    Paper,
    Box,
} from '@material-ui/core';
import moment from 'moment-timezone';
import { Controller } from 'react-hook-form';

import { DesktopDatePicker, LocalizationProvider } from '@material-ui/pickers-next';
import MomentUtilsNext from '@material-ui/pickers-next/adapter/moment';

import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { notifyError } from '~/common/notifications';
import { makeStyles } from '@material-ui/styles';

import classNames from 'classnames';
import { TextFieldOutlined } from '~/common/text-field-outlined';
import { Pagination } from '@material-ui/lab';
import { axiosInstance } from '~/api/config/axios.config';
import { Moment } from 'moment';
import { useDateFormat } from '~/common/date-format';
moment.tz.setDefault('GMT');
interface Step_4Props {
    prevStep: () => void;
}

export const Step_4: React.FC<Step_4Props> = ({ prevStep }) => {
    const { selectedDateFormat } = useDateFormat();
    const [startDate, setStartDate] = React.useState('');
    const [endDate, setEndDate] = React.useState('');
    const [firstDate, setFirstDate] = React.useState('');
    const [paymentMethod, setPaymentMethod] = React.useState('0');
    const [paymentCycle, setPaymentCycle] = React.useState<string[]>([]);
    const [coverCycle, setCoverCycle] = React.useState<string[]>([]);
    const [noendDate, setNoendDate] = React.useState(false);
    const [showEndDate, setShowEndDate] = React.useState(true);
    const dispatch = useThunkDispatch();
    const newDealState = useSelector(selectNewDeal);
    const dealID = newDealState?.contractRefNum;

    useEffect(() => {
        getInvoice();
    }, []); // eslint-disable-line

    const getInvoice = async () => {
        axiosInstance.get('Catalogue/projectcreator/invoicelist', { params: { dealId: dealID } }).then(({ data }) => {
            if (data.length > 0) {
                if (data[0].isDateNotKnown === 1) {
                    return [];
                }

                let sD = data[0].startDate === '1900-01-01T00:00:00' ? '' : moment.utc(data[0].startDate).format('YYYY-MM-DD');
                setStartDate(sD);
                let eD = data[0].endDate === '1900-01-01T00:00:00' ? '' : moment.utc(data[0].endDate).format('YYYY-MM-DD');

                if (data[0].isNoEndDate === 1) {
                    setNoendDate(data[0].isNoEndDate);
                    setShowEndDate(false);
                    setEndDate('');
                } else {
                    setEndDate(eD);
                }

                let fD = moment.utc(data[0].paymentDate).format('YYYY-MM-DD');
                setFirstDate(fD);

                if (!paymentMethod) {
                    setPaymentMethod(data[0].paymentMethod || 0);
                }
            }
        });
    };

    // const dateListFormat = (item: any) => {
    //     var d = new Date(item);
    //     return moment(d).format(GLOBAL_DISPLAY_FORMAT);
    // };

    // number of months
    const getPeriodById = (periodId: number = 1) => {
        switch (periodId) {
            // monthly
            case 0:
                return 1;
            // quaterly
            case 1:
                return 3;
            // Bi-annual
            case 2:
                return 6;
            // Yearly
            case 3:
                return 12;
            // monthly
            default:
               return 1;
        }
    };

    const getPeriodNameById = (periodId: number = 1) => {
        switch (periodId) {
            // monthly
            case 0:
                return 'month';
            // quarterly
            case 1:
                return 'quarter';
            // Bi-annual
            case 2:
                return 'quarter';
            // Yearly
            case 3:
                return 'year';
            // monthly
            default:
                return 'month';
        }
    };

    const getStartDateForCoverPeriods = (periodId: number, fpd: Date | string): Date => {
        const period = getPeriodById(periodId);
        const periodName = getPeriodNameById(periodId);
        const subtracted = moment.utc(fpd).subtract(period, 'M');
        if (period === 6) {
            const fpdQuarter = moment.utc(fpd).quarter();
            return subtracted.quarter(fpdQuarter < 3 ? 4 : 2).endOf(periodName).toDate();
        }
        return subtracted.endOf(periodName).toDate();
    };

    const getEndDateForPaymentPeriods = (periodId: number, ed: Date | string): Date => {
        const period = getPeriodById(periodId);
        const periodName = getPeriodNameById(periodId);
        let endOfPeriods = moment.utc(ed).endOf(periodName);
        if (period === 6) {
            const edQuarter = moment.utc(ed).quarter();
            endOfPeriods = moment.utc(ed).quarter(edQuarter < 3 ? 2 : 4).endOf(periodName);
            if (endOfPeriods.startOf('day').valueOf() > moment.utc(ed).startOf('day').valueOf()) {
                return endOfPeriods.subtract(period, 'M').quarter(edQuarter < 3 ? 4 : 2).endOf(periodName).toDate();
            }
            return endOfPeriods.toDate();
        }
        if (endOfPeriods.startOf('day').valueOf() > moment.utc(ed).startOf('day').valueOf()) {
            return endOfPeriods.subtract(period, 'M').endOf(periodName).toDate();
        }
        return endOfPeriods.endOf(periodName).toDate();
    };

    const getRange = (
        periodId: number,
        from: Date | string,
        to: Date | string = '2025-12-31',
        format = 'YYYY-MM-DD',
        includeLast = false,
        endOfPeriod = false
    ) => {
        const period = getPeriodById(periodId); // number of month
        const periodName = getPeriodNameById(periodId); // name of period
        let currentDate = moment.utc(from);
        const result: string[] = [currentDate.format(format)];
        const day = currentDate.get('date');

        while (currentDate.isSameOrBefore(moment.utc(to))) {
            let nextDate = currentDate.add(period, 'M');
            if (endOfPeriod) {
                nextDate = nextDate.endOf(periodName).startOf('day');
            } else {
                if (nextDate.dates() < day) {
                    nextDate = nextDate.endOf('month');
                } else {
                    nextDate = nextDate.set('date', day);
                }
            }
            if (nextDate.startOf('day').valueOf() <= moment.utc(to).startOf('day').valueOf() || includeLast) {
                result.push(nextDate.format(format));
            }
            currentDate = nextDate;
        }

        return result;
    }

    // // TODO: must be refactored
    // const newDateRange = (gap: any, firstDate: Date | string, startDate?: Date | string, endDate: Date | string = '2025-12-31') => {
    //     let maingap = 1;
    //     switch (gap) {
    //         // monthly
    //         case 0:
    //             maingap = 1;
    //             break;
    //         // quaterly
    //         case 1:
    //             maingap = 3;
    //             break;
    //         // Bi-annual
    //         case 2:
    //             maingap = 6;
    //             break;
    //         // Yearly
    //         case 3:
    //             maingap = 12;
    //             break;
    //         // monthly
    //         default:
    //             maingap = 1;
    //             break;
    //     }
    //
    //     let enddate = endDate;
    //
    //     // @ts-ignore
    //     let f = new Date(startDate || firstDate);
    //     if (maingap === 1) {
    //         f = moment(f).subtract(1, 'M').toDate();
    //     }
    //     let e = new Date(enddate);
    //     if (f.getTime() >= e.getTime()) {
    //         notifyError({
    //             title: 'Error',
    //             message: 'End date must be after start and first payment date',
    //         });
    //     }
    //
    //     if (maingap === 3) {
    //         f = moment(f).startOf('quarter').set('date', moment(f).get('date')).toDate(); // set date
    //         e = moment(e).endOf('quarter').set('date', moment(e).get('date')).toDate(); // set date
    //     }
    //
    //     if (maingap === 6) {
    //         const startQ = moment(f).quarter();
    //         const endQ = moment(e).quarter();
    //         f = moment(f).quarter(startQ < 3 ? 1 : 3).startOf('quarter').set('date', moment(f).get('date')).toDate();
    //         e = moment(e).quarter(endQ < 3 ? 1 : 3).endOf('quarter').set('date', moment(e).get('date')).toDate();
    //     }
    //
    //     let a: any[] = [f];
    //
    //     let filterUniqueDates = (names: any[]) => names.filter((v: any, i: any) => names.indexOf(v) === i);
    //
    //     const range = (g: any) => {
    //         // get previous month date (initially its first date)
    //         const prevDate = new Date(a[a.length - 1]);
    //         // if endDate is less than prevDate stop the loop.
    //         if (e < prevDate) {
    //             let ap: any[] = [];
    //             // get unique values from array
    //             filterUniqueDates(a).map(item => ap.push(dateListFormat(new Date(item))));
    //
    //             // remove first Date from array because we consider it for starting point
    //             ap.splice(-1, 1);
    //             // we generate 3 cycle's
    //             setPaymentCycle(ap);
    //
    //             // when payment cycles set delete error of empty payment cycle from UI
    //         } else {
    //             // get last date (month) of the first date
    //
    //             // to avoid confusion in 30,31,29,28 end date of the month.
    //             // if first date is last date of the month. we get first date of the next month then calculate last date of the month
    //             let prevMonth = new Date(moment(prevDate).format('YYYY-MM-DD')).getMonth();
    //             let prevDay = new Date(moment(prevDate).format('YYYY-MM-DD')).getDate();
    //
    //             let newDate = new Date(moment(prevDate).add(g, 'M').format('YYYY-MM-DD'));
    //             if (Number(prevMonth) === 1 && prevDay >= 28) {
    //                 newDate.setDate(f.getDate());
    //             } else if ([1, 3, 5, 8, 10].includes(Number(prevMonth))) {
    //                 newDate.setDate(f.getDate());
    //             }
    //
    //             a.push(newDate);
    //             range(g);
    //         }
    //     };
    //     range(maingap);
    // };

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPaymentMethod((event.target as HTMLInputElement).value);
    };

    React.useEffect(() => {
        setPaymentMethod(String(newDealState?.contractAccounting) || '0');
    }, [newDealState]);

    const initialFormValues = useMemo(
        () => ({
            startDate: startDate || null,
            endDate: endDate || null,
            firstDate: firstDate || null,
            // paymentCycle: paymentCycle || null,
            accountingTerm: String(newDealState?.contractAccounting || AccountingTerm.NULL),
            paymentNotes: newDealState?.paymentNotes || '',
            // periodItCovers: periodItCovers || null,
        }),
        [newDealState?.contractAccounting, newDealState?.endDate, newDealState?.startDate] // eslint-disable-line
    );

    const { handleSubmit, errors, control, register, setError, clearErrors } = useForm({
        defaultValues: { ...initialFormValues },
    });

    const createInvoice = useCallback(() => {
        const isDateNotKnown = !firstDate.trim() && !startDate.trim() && !endDate.trim();
        if (isDateNotKnown) {
            axiosInstance.post('catalogue/projectCreator/createinvoice', {
                dealID: dealID,
                startDate: null,
                endDate: null,
                paymentDate: null,
                paymentMethod: Number(paymentMethod),
                periodItCovers: [],
                paymentDateAvailable: [],
                isNoEndDate: 1,
                isDateNotKnown: 1,
            });
        } else {
            axiosInstance.post('catalogue/projectCreator/createinvoice', {
                dealID: dealID,
                startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '1900-01-01',
                endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '1900-01-01',
                paymentDate: moment(firstDate).format('YYYY-MM-DD'),
                paymentMethod: Number(paymentMethod),
                isNoEndDate: noendDate ? 1 : null,
                isDateNotKnown: 0,
                paymentDateAvailable: paymentCycle.map(d => moment.utc(d).format('YYYY-MM-DD')),
                periodItCovers: coverCycle,
            });
        }
    }, [coverCycle, dealID, endDate, firstDate, noendDate, paymentCycle, paymentMethod, startDate]);

    const onSubmit = useCallback(
        (data: INewDealStepFourFormInputs) => {
            createInvoice();
            const isDirty = !deepEqual(initialFormValues, data);

            dispatch(createNewDealStepFourThunk({ ...data, isDirty }));
        },
        [initialFormValues, createInvoice] // eslint-disable-line
    );

    const createPaymentCycle = (gap: number, firstDate: any, endDate: any, startDate: any) => {
        if (firstDate.trim() !== '') {
            // generate payment cycle
            // newDateRange(gap, firstDate, startDate || undefined, endDate || undefined);
            const paymentPeriods = getRange(gap, firstDate, getEndDateForPaymentPeriods(gap, endDate), selectedDateFormat, true);
            const coverPeriods = getRange(gap, getStartDateForCoverPeriods(gap, firstDate), endDate, undefined, false, true);
            // console.log('LOG', { paymentPeriods: paymentPeriods.map(d => moment.utc(d).format('DD/MM/YYYY')), coverPeriods: coverPeriods.map(d => moment.utc(d).format('DD/MM/YYYY')) });
            setPaymentCycle(paymentPeriods);
            setCoverCycle(coverPeriods);
        } else {
            notifyError({
                title: 'Error',
                message: 'First Payment date must be provided',
            });
        }
    };

    const useStyles = makeStyles({
        perdisabled: {
            color: 'gray',
        },
    });

    const handleCheckBox = () => {
        setEndDate('');
        setNoendDate(!noendDate);
        setShowEndDate(!showEndDate);
    };

    const classes = useStyles();
    React.useEffect(() => {
        if (firstDate.trim() !== '') {
            createPaymentCycle(Number(paymentMethod), firstDate, (!endDate || noendDate) ? '2025-12-31' : endDate, startDate || firstDate);
        } else {
            setPaymentCycle([]);
            setCoverCycle([]);
        }
    }, [paymentMethod, firstDate, endDate, startDate]); // eslint-disable-line

    // pagination
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 5;
    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfItemDeals = indexOfLastItem - ITEMS_PER_PAGE;
    const pagesCount = Math.ceil(paymentCycle.length / ITEMS_PER_PAGE);
    const currentItems = paymentCycle.slice(indexOfItemDeals, indexOfLastItem);

    useEffect(() => {
        setCurrentPage(1);
    }, [paymentCycle]);

    return (
        <Box className={css.module}>
            <Box className={css.wrapper}>
                <Paper square elevation={0} className={classNames(css.paper, css.header)}>
                    <Typography align={'left'} variant={'h5'}>
                        {newDealState?.contractTitle}
                    </Typography>
                </Paper>
                <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={3}>
                        <Grid container item xs={7} spacing={2}>
                            <Grid item xs={12}>
                                <Box display="flex" alignItems="center">
                                    <LocalizationProvider dateAdapter={MomentUtilsNext}>
                                        <Box className={css.datepickercustomouter} marginRight="143px">
                                            <Controller
                                                render={() => (
                                                    <DesktopDatePicker
                                                        onChange={newValue => {
                                                            clearErrors('startDate');
                                                            if (!newValue) {
                                                                setStartDate('');
                                                            } else if (newValue.isValid()) {
                                                                setStartDate((newValue as Moment).format('YYYY-MM-DD') || '');
                                                            } else {
                                                                setError('startDate', { message: 'Invalid date' });
                                                            }
                                                        }}
                                                        value={startDate.trim() === '' ? null : moment(new Date(new Date(startDate).toISOString()))}
                                                        inputFormat={selectedDateFormat}
                                                        // inputFormat="DD/MM/YYYY"
                                                        // inputFormat="MM/DD/YYYY"
                                                        renderInput={(props: any) => (
                                                            <TextFieldOutlined
                                                                {...props}
                                                                error={!!errors?.startDate}
                                                                // helperText={(errors.startDate?.message) || 'MM/DD/YYYY'}
                                                                helperText={errors.startDate?.message}
                                                                label="Start Date"
                                                                name="startDate"
                                                            />
                                                        )}
                                                    />
                                                )}
                                                name={'startDate'}
                                                control={control}
                                            />
                                        </Box>
                                    </LocalizationProvider>
                                </Box>
                            </Grid>
                            <Grid container item xs={12}>
                                <Box display="flex" alignItems="center" width="100%">
                                    <LocalizationProvider dateAdapter={MomentUtilsNext}>
                                        <div className={css.datepickercustomouter}>
                                            <Controller
                                                render={() => (
                                                    <DesktopDatePicker
                                                        disabled={!showEndDate}
                                                        onChange={newValue => {
                                                            clearErrors('endDate');
                                                            if (!newValue) {
                                                                setEndDate('');
                                                            } else if (newValue.isValid()) {
                                                                setEndDate((newValue as Moment).format('YYYY-MM-DD') || '');
                                                            } else {
                                                                setError('endDate', { message: 'Invalid date' });
                                                            }
                                                        }}
                                                        value={endDate.trim() === '' ? null : moment(new Date(endDate).toISOString())}
                                                        inputFormat={selectedDateFormat}
                                                        // inputFormat="DD/MM/YYYY"
                                                        // inputFormat="MM/DD/YYYY"
                                                        minDate={
                                                            startDate.trim() === ''
                                                                ? undefined
                                                                : moment.utc(new Date(new Date(startDate).toISOString()))
                                                        }
                                                        renderInput={(props: any) => (
                                                            <TextFieldOutlined
                                                                {...props}
                                                                error={showEndDate && !!errors?.endDate}
                                                                // helperText={(showEndDate && errors.endDate?.message) || 'MM/DD/YYYY'}
                                                                helperText={(showEndDate && errors.endDate?.message) || ' '}
                                                                label="End Date"
                                                                name={'endDate'}
                                                            />
                                                        )}
                                                    />
                                                )}
                                                name={'endDate'}
                                                control={control}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                    <FormControlLabel
                                        control={<Checkbox checked={!!noendDate} onChange={() => handleCheckBox()} name="checkedA" />}
                                        className={classNames(css.checkbox, classes.perdisabled)}
                                        label="In Perpetuity"
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" alignItems="center">
                                    <LocalizationProvider dateAdapter={MomentUtilsNext}>
                                        <div className={css.datepickercustomouter}>
                                            <Controller
                                                render={() => (
                                                    <DesktopDatePicker
                                                        onChange={newValue => {
                                                            clearErrors('firstDate');
                                                            if (!newValue) {
                                                                setFirstDate('');
                                                            } else if (newValue.isValid()) {
                                                                setFirstDate((newValue as Moment).format('YYYY-MM-DD') || '');
                                                                // delete errors['firstDate'];
                                                            } else {
                                                                setError('firstDate', { message: 'Invalid date' });
                                                            }
                                                        }}
                                                        value={firstDate.trim() === '' ? null : moment(new Date(firstDate).toISOString())}
                                                        inputFormat={selectedDateFormat}
                                                        // inputFormat="DD/MM/YYYY"
                                                        // inputFormat="MM/DD/YYYY"
                                                        minDate={
                                                            startDate.trim() === ''
                                                                ? undefined
                                                                : moment.utc(new Date(new Date(startDate).toISOString()))
                                                        }
                                                        maxDate={
                                                            (endDate.trim() === '' || noendDate)
                                                                ? undefined
                                                                : moment.utc(new Date(new Date(endDate).toISOString()))
                                                        }
                                                        renderInput={(props: any) => (
                                                            <TextFieldOutlined
                                                                {...props}
                                                                error={!!errors?.firstDate}
                                                                helperText={(errors.firstDate?.message)}
                                                                // helperText={(errors.firstDate?.message) || 'MM/DD/YYYY'}
                                                                label="First payment date"
                                                                name={'firstDate'}
                                                            />
                                                        )}
                                                    />
                                                )}
                                                name={'firstDate'}
                                                control={control}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                    <Button
                                        disabled={!firstDate}
                                        className={classNames(css.button, css.generatebutton)}
                                        onClick={() => {
                                            createPaymentCycle(Number(paymentMethod), firstDate, endDate || '2025-12-31', startDate || firstDate);
                                        }}
                                    >
                                        Generate
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box>
                                    <TextFieldOutlined
                                        label="Payment notes"
                                        id="payment-cycle-date"
                                        type="text"
                                        name="paymentNotes"
                                        inputRef={register}
                                        noHelperText
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={5} className={css.rightSide}>
                            <Paper className={`${css.paper} ${css.datesDetails}`} square>
                                <Typography className={css.listHead}>Payment Dates Details</Typography>
                                <List className={css.paymentul}>
                                    {paymentCycle?.length > 0 ? (
                                        <>
                                            {currentItems.map((item: any, i: any) => (
                                                <ListItem key={i}>
                                                    <ArrowRightAltIcon />
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </>
                                    ) : (
                                        <ListItem />
                                    )}
                                </List>
                                {pagesCount > 1 && (
                                    <div className={css.pageNoList}>
                                        <Typography className={css.total}>Total: {paymentCycle.length}</Typography>
                                        <Pagination
                                            className={css.pagination}
                                            count={pagesCount}
                                            page={currentPage}
                                            onChange={(event: any, value: any) => {
                                                setCurrentPage(value);
                                            }}
                                            variant="outlined"
                                            shape="rounded"
                                            hideNextButton
                                            hidePrevButton
                                        />
                                    </div>
                                )}
                            </Paper>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <RadioGroup
                            style={{ width: '100%' }}
                            row
                            name="terms"
                            value={paymentMethod}
                            onChange={handleRadioChange}
                            ref={register}
                        >
                            <FormControlLabel
                                className={css.radioBox}
                                inputRef={register}
                                value="0"
                                control={<Radio color="primary" />}
                                label="Monthly"
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                className={css.radioBox}
                                inputRef={register}
                                value="1"
                                control={<Radio color="primary" />}
                                label="Quarterly"
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                className={css.radioBox}
                                inputRef={register}
                                value="2"
                                control={<Radio color="primary" />}
                                label="Bi-annual"
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                className={css.radioBox}
                                inputRef={register}
                                value="3"
                                control={<Radio color="primary" />}
                                label="Yearly"
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid container>
                        <StepControls onPrevClick={prevStep} errors={errors} />
                    </Grid>
                </form>
            </Box>
        </Box>
    );
};
